import React, { useContext, useEffect, useState } from "react";
import "./AddTeacherForm.css";
import TextFieldInput from "../../../Atoms/Inputs/TextField/TextFieldInput";
import PrimaryButton from "../../../Atoms/Buttons/Primary/PrimaryButton";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Typography } from "@mui/material";
import useEdit from "../../../../Hooks/useEdit";
import useSave from "../../../../Hooks/useSave";
import {
  BaseURL,
  profileURL,
  schoolListURL,
  teacherURL,
} from "../../../../Hooks/URL";
import { Formik } from "formik";
import * as Yup from "yup";
import useFetch from "../../../../Hooks/useFetch";
import phone from "phone";
import { PhoneInput } from "react-international-phone";
import useFetchWhen from "../../../../Hooks/useFetchWhen";
import { userContext } from "../../../../Contexts/userContext";
import { images } from "../../../../Assets/assetsHelper";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import { PulseLoader } from "react-spinners";

const AdminTeacherSchema = Yup.object().shape({
  name: Yup.string().required("Name required !!"),
  email: Yup.string().email("Invalid email !!").required("Email required !!"),
  gender: Yup.string().required("Gender required !!"),
});

const TeacherSchema = Yup.object().shape({
  name: Yup.string().required("Name required !!"),
  email: Yup.string().email("Invalid email !!").required("Email required !!"),
  gender: Yup.string().required("Gender required !!"),
});

function AddTeacherForm({ Edit = false, teacher, url, EditSelf = false }) {
  const { contextData, setContextData } = useContext(userContext);
  const navigate = useNavigate();
  const [file, setFile] = useState("");
  const [newObject, setNewObject] = useState({});
  const [Phone, setPhone] = useState("");
  const [PhoneError, setPhoneError] = useState(null);
  const [PhoneTouched, setPhoneTouched] = useState(false);
  const [goEdit, setGoEdit] = useState(false);
  const [goSave, setGoSave] = useState(false);
  const { state, loading: editLoading } = useEdit(
    EditSelf ? `${profileURL}/teacher` : url,
    goEdit,
    setGoEdit,
    newObject,
    false,
    true
  );
  const { saveState, loading: addLoading } = useSave({
    url: teacherURL,
    goSave,
    setGoSave,
    newObject,
    isImage: true,
  });
  const { data: schoolsList } = useFetchWhen(
    schoolListURL,
    contextData?.role == "admin"
  );

  const handleUploadClick = (e) => {
    setFile(e.target.files[0]);
  };

  useEffect(() => {
    if (!phone(Phone)?.isValid) setPhoneError("Valid Phone Number Required!!");
    else setPhoneError("");
  }, [Phone]);

  useEffect(() => {
    if (teacher) {
      setPhone(teacher?.phone);
    }
  }, [teacher]);

  useEffect(() => {
    if (state.dataRes.status == "success") {
      navigate(EditSelf ? "/account" : "/instructors");
    }
  }, [state]);

  useEffect(() => {
    if (saveState.dataRes.status == "success") {
      navigate("/instructors");
    }
  }, [saveState]);

  return (
    <div className="SmallFormWrapper">
      <Formik
        initialValues={
          contextData?.role == "admin"
            ? {
                name: Edit ? teacher?.name ?? "" : "",
                email: Edit ? teacher?.email ?? "" : "",
                gender: Edit ? teacher?.gender ?? "" : "",
                nationalId: Edit ? teacher?.nationalId ?? "" : "",
                schoolId: Edit ? teacher?.school?.id ?? -1 : -1,
              }
            : {
                name: Edit ? teacher?.name ?? "" : "",
                email: Edit ? teacher?.email ?? "" : "",
                gender: Edit ? teacher?.gender ?? "" : "",
                nationalId: Edit ? teacher?.nationalId ?? "" : "",
              }
        }
        validationSchema={
          contextData?.role == "admin" ? AdminTeacherSchema : TeacherSchema
        }
        onSubmit={(values) => {
          if (!PhoneError)
            if (teacher) {
              const prev =
                contextData?.role == "admin"
                  ? {
                      name: teacher?.name ?? "",
                      phone: teacher?.phone ?? "",
                      email: teacher?.email ?? "",
                      gender: teacher?.gender ?? "",
                      nationalId: teacher?.nationalId ?? "",
                      schoolId: teacher?.school?.id ?? -1,
                    }
                  : {
                      name: teacher?.name ?? "",
                      phone: teacher?.phone ?? "",
                      email: teacher?.email ?? "",
                      gender: teacher?.gender ?? "",
                      nationalId: teacher?.nationalId ?? "",
                    };
              if (file)
                setNewObject({
                  ...Object.fromEntries(
                    Object.entries({
                      ...prev,
                      ...values,
                      phone: Phone,
                    }).filter(([key]) => prev[key] != values[key])
                  ),
                  photo: file,
                });
              else
                setNewObject(
                  Object.fromEntries(
                    Object.entries({
                      ...prev,
                      ...values,
                      phone: Phone,
                    }).filter(([key]) => prev[key] != values[key])
                  )
                );
              setGoEdit(true);
            } else {
              setNewObject({
                photo: file,
                phone: Phone,
                ...values,
              });
              setGoSave(true);
            }
          else {
            setPhoneTouched(true);
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <form autoComplete="off" onSubmit={handleSubmit}>
            <div className="FormContainer">
              <div className="LeftForm">
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-end",
                    justifyContent: "space-between",
                    marginBottom: "20px",
                  }}
                >
                  <div style={{ position: "relative" }}>
                    <label
                      className="aboutLabel"
                      style={{ marginBottom: "20px" }}
                    >
                      Instructor Photo:
                    </label>
                    {(file && file !== "null") ||
                    (teacher?.photo && file !== "null") ? (
                      <Button
                        component="label"
                        variant="contained"
                        color="secondary"
                        startIcon={<CloseIcon style={{ fontSize: "20" }} />}
                        className="ImageInputButton RemovePhoto"
                        onClick={() => {
                          setFile("null");
                        }}
                      />
                    ) : (
                      ""
                    )}
                    <img
                      src={
                        file && file !== "null"
                          ? URL.createObjectURL(file)
                          : teacher?.photo && file !== "null"
                          ? `${BaseURL}/${teacher?.photo}`
                          : images.upload
                      }
                      style={{
                        width: "120px",
                        height: "120px",
                        cursor: "pointer",
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                      onClick={() => {
                        setFile("null");
                      }}
                    />
                    <Button
                      component="label"
                      variant="contained"
                      startIcon={<CloudUploadIcon style={{ fontSize: "25" }} />}
                      className="ImageInputButton uploadButton"
                    >
                      <input
                        accept="image/*"
                        className={"ImageInput"}
                        id="contained-button-file"
                        type="file"
                        onChange={handleUploadClick}
                      />
                    </Button>
                  </div>
                </div>
                <TextFieldInput
                  fullWidth
                  type="text"
                  placeholder={"Enter Instructor Name"}
                  className="Input"
                  label={"Instructor Name"}
                  name={"name"}
                  change={handleChange}
                  blur={handleBlur}
                  newValue={values.name}
                />
                {errors.name && touched.name && errors.name && (
                  <p className="error">
                    {errors.name && touched.name && errors.name}
                  </p>
                )}

                {!Edit ? (
                  <>
                    <TextFieldInput
                      fullWidth
                      type="email"
                      placeholder={"Enter Instructor Email"}
                      className="Input"
                      label={"Instructor Email"}
                      name={"email"}
                      change={handleChange}
                      blur={handleBlur}
                      newValue={values.email}
                    />
                    {errors.email && touched.email && errors.email && (
                      <p className="error">
                        {errors.email && touched.email && errors.email}
                      </p>
                    )}
                  </>
                ) : (
                  ""
                )}
              </div>
              <div className="RightForm">
                <div style={{ position: "relative", marginBottom: "20px" }}>
                  <label className="labelPhone">Phone Number</label>
                  <PhoneInput
                    label={"Enter Instructor Phone Number"}
                    className="textfield Input phoneInput"
                    value={Phone}
                    defaultCountry="eg"
                    onChange={(e) => {
                      setPhone(e);
                    }}
                  />
                  {PhoneError && PhoneTouched ? (
                    <p className="error">{PhoneError}</p>
                  ) : (
                    ""
                  )}
                </div>

                <TextFieldInput
                  select
                  label="Gender"
                  newValue={values.gender}
                  name={"gender"}
                  change={handleChange}
                  blur={handleBlur}
                  fullWidth
                  className={`CourseSelect Input`}
                  variant="outlined"
                  SelectProps={{
                    displayEmpty: true,
                  }}
                >
                  <MenuItem value="" className="teacherSelect" disabled>
                    Choose Instructor Gender
                  </MenuItem>
                  <MenuItem value="male">Male</MenuItem>
                  <MenuItem value="female">Female</MenuItem>
                </TextFieldInput>
                {errors.gender && touched.gender && errors.gender && (
                  <p className="error">
                    {errors.gender && touched.gender && errors.gender}
                  </p>
                )}

                <TextFieldInput
                  fullWidth
                  type="text"
                  placeholder={"Enter Instructor National ID"}
                  className="Input"
                  label={"National ID"}
                  name={"nationalId"}
                  change={handleChange}
                  blur={handleBlur}
                  newValue={values.nationalId}
                  Required={false}
                />
                {errors.nationalId &&
                  touched.nationalId &&
                  errors.nationalId && (
                    <p className="error">
                      {errors.nationalId &&
                        touched.nationalId &&
                        errors.nationalId}
                    </p>
                  )}

                {contextData?.role == "admin" ? (
                  <>
                    <TextFieldInput
                      select
                      Required={false}
                      label="School"
                      newValue={values.schoolId}
                      name={"schoolId"}
                      change={handleChange}
                      blur={handleBlur}
                      fullWidth
                      className={`CourseSelect Input`}
                      variant="outlined"
                      SelectProps={{
                        displayEmpty: true,
                      }}
                    >
                      <MenuItem value="" className="teacherSelect" disabled>
                        Choose School
                      </MenuItem>
                      <MenuItem value={-1}>Skill Code</MenuItem>
                      {schoolsList?.data?.map((schoolItem) => (
                        <MenuItem value={schoolItem?.id}>
                          {schoolItem?.name}
                        </MenuItem>
                      ))}
                    </TextFieldInput>
                    {errors.schoolId && touched.schoolId && errors.schoolId && (
                      <p className="error">
                        {errors.schoolId && touched.schoolId && errors.schoolId}
                      </p>
                    )}
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>

            <div style={{ display: "flex", justifyContent: "center" }}>
              <button
                className="actionButton primary addButton"
                onClick={handleSubmit}
                disabled={Edit ? editLoading : addLoading}
              >
                {Edit ? (
                  editLoading ? (
                    <PulseLoader color="white" size={8} />
                  ) : (
                    "Edit"
                  )
                ) : addLoading ? (
                  <PulseLoader color="white" size={8} />
                ) : (
                  "Add"
                )}
              </button>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
}

export default AddTeacherForm;
